import { render, staticRenderFns } from "./ComposeEmail.vue?vue&type=template&id=f2b68c92"
import script from "./ComposeEmail.vue?vue&type=script&lang=js"
export * from "./ComposeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports